import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-saintbrand-shipping';

const contentHtml = `
<div
  id="saintbrand-shipping-unique-id"
  data-id="unique-id"
  class="saintbrand-shipping"
  data-attribute="saintbrand-shipping"
>
  <div
    class="saintbrand-shipping__bar"
    data-attribute="saintbrand-shipping-bar"
    data-background="#f6f6f6"
    data-border-radius="20"
    style="--bar-background: #f6f6f6; --bar-border-radius: 20px;"
  >
    <div class="saintbrand-shipping__left" data-attribute="saintbrand-shipping-left">
      <span
        class="saintbrand-shipping__dot"
        data-attribute="saintbrand-shipping-dot"
        data-dot-color="#22c55e"
        style="--dot-color: #22c55e;"
      ></span>
      <span class="saintbrand-shipping__ship-text" data-attribute="saintbrand-shipping-ship">
        <span data-attribute="saintbrand-shipping-ship-prefix">Ships by </span>
        <strong class="saintbrand-shipping__ship-date" data-attribute="saintbrand-shipping-ship-date">Mon, Jun 15</strong>
      </span>
    </div>
    <div class="saintbrand-shipping__right" data-attribute="saintbrand-shipping-right">
      <img
        class="saintbrand-shipping__flag"
        data-attribute="saintbrand-shipping-flag"
        src="https://flagcdn.com/w40/us.png"
        alt="Flag"
        width="24"
        height="16"
      />
      <span class="saintbrand-shipping__location-text" data-attribute="saintbrand-shipping-location">
        <span data-attribute="saintbrand-shipping-location-prefix">Fast </span>
        <strong data-attribute="saintbrand-shipping-country-code">US</strong>
        <span data-attribute="saintbrand-shipping-location-suffix"> Shipping</span>
      </span>
    </div>
  </div>
  <span
    data-attribute="saintbrand-shipping-delivery-days"
    data-delivery-days="14"
    hidden
  ></span>
</div>
`;

export default containerFuild(contentHtml, css, {
  bottomPadding: false,
});
